import { Box, Button, CircularProgress, Typography } from '@mui/material';
import usePackingListFileUrl, { useOriginalDownload } from '../../../hooks/usePackingListFileUrl';
import SplitPane from './SplitPane';
import DocumentViewer from './DocumentViewer';

/**
 * 올린 원본의 파싱이 끝나기를 기다리는 화면. 왼쪽에 원본(보기·다운로드), 오른쪽에 진행 안내를 둔다.
 * 라인 편집은 파싱 결과가 초안으로 반영된 뒤(packing_list:parsed → 재조회) 검수 화면에서 한다.
 * 엑셀 원본은 서버가 파싱 중에 화면용 PDF를 만들므로, 생기는 대로 받아 격자 대신 PDF로 바꾼다(waitForPreview).
 * 주기 재조회 상한이 지나면 혼자 묻기를 멈추고 Check again으로 담당자가 다시 묻게 한다.
 * 창을 닫을지는 다이얼로그가 정한다 — 아직 Draft로 저장하지 않은 업로드면 떠나기 전에 버릴지 묻는다.
 */
export default function PLParsingView({ doc, commands, onClose, pollExhausted = false, onCheckAgain = null }) {
    const file = usePackingListFileUrl(commands, { docId: doc.id, hasFile: doc.input_source !== 'manual', waitForPreview: true });
    const { download, downloading } = useOriginalDownload(commands);
    const filename = file.file?.original_filename ?? 'the document';
    const queued = doc.upload_status === 'queued';
    return (
        <Box sx={{ height: '100%', minHeight: 0, bgcolor: 'white' }}>
            <SplitPane
                first={<DocumentViewer doc={doc} raw={null} lines={[]} activeRef={null} onPickLine={() => {}} file={file} onDownload={() => download(doc.id)} downloading={downloading} />}
                second={
                    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2, p: 4, bgcolor: '#f3f4f3' }}>
                        <CircularProgress size={32} />
                        <Typography sx={{ fontSize: 14, fontWeight: 500, color: '#003a52' }} noWrap title={filename}>Parsing {filename}…</Typography>
                        {queued && <Typography sx={{ fontSize: 11, color: 'text.secondary', mt: -1.5 }}>Queued — a parser will pick it up shortly.</Typography>}
                        {pollExhausted ? (
                            <>
                                <Typography sx={{ fontSize: 12, color: 'text.secondary', textAlign: 'center' }}>This is taking longer than usual. The result will still open here when it arrives.</Typography>
                                {onCheckAgain && <Button size="small" variant="outlined" onClick={onCheckAgain} sx={{ fontSize: 12 }}>Check again</Button>}
                            </>
                        ) : (
                            <Typography sx={{ fontSize: 12, color: 'text.secondary', textAlign: 'center' }}>Review opens as soon as the lines are extracted.</Typography>
                        )}
                        {onClose && <Button size="small" onClick={onClose} sx={{ fontSize: 12 }}>Close</Button>}
                    </Box>
                }
            />
        </Box>
    );
}
